module.exports = __webpack_public_path__ + "img/arrow.bb1b7297.svg";